import React, { useEffect, useState } from 'react';
import { getNewsCountry } from '@/pages/opinion/services/news';
import { transRegion } from '@/pages/opinion/utils';
import CardCommon from '@/pages/opinion/components/CardCommon';
import MapCommon from '@/pages/opinion/components/MapCommon';
import { getLocale, useIntl } from 'umi';
import { newsMapTips } from '@/pages/opinion/components/BubbleCommon';

export default function CountryChart({
  regionKind = 'market',
  params,
}: {
  regionKind: string;
  params: any;
}) {
  const [data, setData] = useState<any>({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getNewsCountry({
      ...params,
      types: ['total'],
    })
      .then((data: any) => {
        setData(data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [params]);

  // region 坐标散点图数据
  const [regionData, setRegionData] = useState<any[]>([]);
  const [unidentifiedMentions, setUnidentifiedMentions] = useState(0);
  const [mentionsMax, setMentionsMax] = useState<number>(0);
  const [mentionsTotal, setMentionsTotal] = useState<number>(0);
  const { formatMessage } = useIntl();
  const locale = getLocale();

  const handleRegionData = () => {
    const regionData: { sentimentType: string; color: string; data?: any[] }[] =
      [
        { sentimentType: formatMessage({ id: 'Positive' }), color: '#69D19C' },
        { sentimentType: formatMessage({ id: 'Neutral' }), color: '#6E7794' },
        { sentimentType: formatMessage({ id: 'Negative' }), color: '#F17C86' },
      ];
    // 这个记录总数量，不再记录最大值
    let mentionsTotal = 0;
    let mentionsMax = 0;

    const handleData = (type: string, dataItem: { avg_sentiment: any }) => {
      const positive = regionData.find((item) => item.sentimentType === type);
      if (positive && !positive?.data) positive.data = [];
      positive &&
        positive.data?.push({ ...dataItem, sentiment: dataItem.avg_sentiment });
    };
    let unidentifiedMentions = 0;
    if (data?.mentions?.length > 0) {
      data.mentions.forEach(
        (item: {
          name?: any;
          count?: any;
          value?: any;
          avg_sentiment: any;
        }) => {
          if (item.name.toLocaleLowerCase() === 'unidentified') {
            unidentifiedMentions = item.count;
          } else {
            mentionsMax = Math.max(item.count, mentionsMax);
          }
          mentionsTotal += item?.count; // 记录mentions总数量
          item.value = item?.count; // 散点图value
          item.name = transRegion(item.name, locale === 'zh-CN' ? 4 : 2);
          if (item?.avg_sentiment > 3.5) {
            handleData(formatMessage({ id: 'Positive' }), item);
          } else if (item?.avg_sentiment >= 2.5) {
            handleData(formatMessage({ id: 'Neutral' }), item);
          } else {
            handleData(formatMessage({ id: 'Negative' }), item);
          }
        },
      );
    }

    setUnidentifiedMentions(unidentifiedMentions);
    setRegionData(regionData);
    setMentionsMax(mentionsMax);
    setMentionsTotal(mentionsTotal);
  };

  useEffect(() => {
    handleRegionData();
  }, [data, locale]);

  return (
    <CardCommon
      bodyStyle={{ height: 376 }}
      emptyHeight={376}
      loading={loading}
      loadingHeight={376}
      title={formatMessage({ id: 'Country' })}
    >
      <MapCommon
        data={regionData}
        unidentifiedMentions={unidentifiedMentions}
        max={mentionsMax}
        bubbleTips={newsMapTips}
        total={mentionsTotal}
        keyMentions="News Mentions"
        height={300}
        regionType={regionKind as any}
      />
    </CardCommon>
  );
}
